import { render, staticRenderFns } from "./havePrice.vue?vue&type=template&id=0b23b4bb&scoped=true"
import script from "./havePrice.vue?vue&type=script&lang=js"
export * from "./havePrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b23b4bb",
  null
  
)

export default component.exports